import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';

import { DOCUMENT_VALIDATION, MAIL_ERROR, REQUIRED_FIELD, TIPO_DOC_ENUM } from '../../../../constants/common.constants';
import { validateNIE, validateNIF, validatePassport } from '../../../../utils/generic.utils';

const defaultValues = {
  name: '',
  lastname1: '',
  lastname2: '',
  role: '',
  document: '',
  email: '',
  creationDate: null,
  active: false,
};

const resolver = yupResolver(
  yup.object().shape({
    name: yup.string().required(REQUIRED_FIELD),
    lastname1: yup.string().required(REQUIRED_FIELD),
    lastname2: yup.string(),
    role: yup.string().required(REQUIRED_FIELD),
    documentType: yup.string().required(REQUIRED_FIELD),
    document: yup.string().when('documentType', (documentType, fieldSchema) => {
      const alteredSchema = fieldSchema
        .required(REQUIRED_FIELD)
        .max(25, DOCUMENT_VALIDATION.MAX)
        .min(6, DOCUMENT_VALIDATION.MIN);

      if (documentType === TIPO_DOC_ENUM.PASSPORT)
        return alteredSchema.test('document', DOCUMENT_VALIDATION.PASSPORT, (value) =>
          validatePassport(value));

      if (documentType === TIPO_DOC_ENUM.NIF)
        return alteredSchema.test('document', DOCUMENT_VALIDATION.NIF, (value) =>
          validateNIF(value),
        );
      if (documentType === TIPO_DOC_ENUM.NIE)
        return alteredSchema.test('document', DOCUMENT_VALIDATION.NIE, (value) =>
          validateNIE(value),
        );
      return alteredSchema;
    }),
    email: yup.string().required(REQUIRED_FIELD).email(MAIL_ERROR),
    creationDate: yup.date().required(REQUIRED_FIELD).nullable(),
    active: yup.boolean(),
  })
);

export { defaultValues, resolver };
